import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductArticleListComponent } from './product-article-list/product-article-list.component';
import { ProductFilterComponent } from './product-filter/product-filter.component';
import { ProductHeaderComponent } from './product-header/product-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgOrderByPipeModule, NgWherePipeModule } from 'angular-pipes';
import { ComponentsModule } from '../../../../../components/components.module';
import { CatalogComponentsModule } from '../../../catalog-components/catalog-components.module';
import { PipesModule } from '../../../../../pipes/pipes.module';
import { TranslocoModule } from '@ngneat/transloco';
import { ProductFacetItemComponent } from './product-facet-item/product-facet-item.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

const components: any[] = [ProductHeaderComponent, ProductFilterComponent, ProductArticleListComponent, ProductFacetItemComponent];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    NgOrderByPipeModule,
    ComponentsModule,
    CatalogComponentsModule,
    PipesModule,
    TranslocoModule,
    MatInputModule,
    ReactiveFormsModule,
    NgWherePipeModule,
    NgxPaginationModule,
    FormsModule,
  ],
  exports: components,
})
export class ProductComponentsModule {}
